module.exports = "<p>\n  khb-drawing works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/khb-drawing/khb-drawing.component.html
// module id = ./src/app/planning/khb-drawing/khb-drawing.component.html
// module chunks = main